import { normalizeTime, shiftHours } from './rrhhUtils';

export function plannedSegments(turn) {
  if (!turn || String(turn.estado ?? turn.estado_turno).toUpperCase() !== 'NORMAL') return [];
  if (Array.isArray(turn.tramos_previstos)) return turn.tramos_previstos.map((segment, index) => (
    index === 0 && segment.ubicacion === undefined && turn.ubicacion
      ? { ...segment, ubicacion: turn.ubicacion } : segment
  ));
  return turn.hora_inicio && turn.hora_fin ? [{
    hora_inicio: normalizeTime(turn.hora_inicio),
    hora_fin: normalizeTime(turn.hora_fin),
    actividad_ubicacion: turn.actividad_ubicacion || '',
    ubicacion: turn.ubicacion || '',
  }] : [];
}

export function plannedHours(turn) {
  return plannedSegments(turn).reduce((total, segment) => total + shiftHours(segment.hora_inicio, segment.hora_fin), 0);
}

export function plannedSchedule(turn) {
  return plannedSegments(turn).map((segment) => `${normalizeTime(segment.hora_inicio)} - ${normalizeTime(segment.hora_fin)}`).join(' / ');
}

export function plannedDetails(turn) {
  return plannedSegments(turn).map((segment) => `${normalizeTime(segment.hora_inicio)} - ${normalizeTime(segment.hora_fin)} · ${segment.actividad_ubicacion}`).join(' / ');
}

export function plannedProjection(segments) {
  return {
    hora_inicio: segments[0]?.hora_inicio || null,
    hora_fin: segments.at(-1)?.hora_fin || null,
    actividad_ubicacion: [...new Set(segments.map((segment) => segment.actividad_ubicacion))].join(' / ') || null,
  };
}

export function newEditorSegment(previous) {
  const end = normalizeTime(previous?.end);
  const start = normalizeTime(previous?.start);
  const minutes = end ? Number(end.slice(0, 2)) * 60 + Number(end.slice(3)) + 60 : null;
  // All segment entries belong to this date; do not wrap into its previous morning.
  const suggested = minutes !== null && minutes < 1440 && (!start || end >= start)
    ? `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}` : '';
  return { start: suggested, end: '', activity: '', location: '', autoStart: suggested };
}

export function editorSegments(segments) {
  const clean = segments.filter((segment) => (
    (segment.start.trim() && segment.start !== segment.autoStart)
    || segment.end.trim() || segment.activity.trim() || segment.location?.trim()
  ))
    .map((segment) => ({
      hora_inicio: normalizeTime(segment.start),
      hora_fin: normalizeTime(segment.end),
      actividad_ubicacion: segment.activity.trim().toUpperCase(),
      ...(segment.location !== undefined ? { ubicacion: segment.location.trim() } : {}),
    }));
  if (!clean.length || clean.some((segment) => !segment.hora_inicio || !segment.hora_fin || !segment.actividad_ubicacion)) {
    throw new Error('Completá entrada, salida y referencia de cada tramo');
  }
  clean.sort((a, b) => a.hora_inicio.localeCompare(b.hora_inicio));
  const minute = (time) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3));
  let previousEnd = -1;
  clean.forEach((segment) => {
    const start = minute(segment.hora_inicio);
    let end = minute(segment.hora_fin);
    if (start === end) throw new Error('La entrada y la salida no pueden ser iguales');
    if (start < previousEnd) throw new Error('Los tramos no pueden superponerse');
    if (end < start) end += 1440;
    previousEnd = end;
  });
  return clean;
}
